export default __webpack_public_path__ + "static/media/social-01@2x.2a268a2f.jpg";